// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout_mainLayout__kO5ej","MainBody":"mainLayout_MainBody__E7Q9F","outlet-wrapper":"mainLayout_outlet-wrapper__VpEMT"};